export default __webpack_public_path__ + "static/media/5.c0a33a5c.jpg";